import { useTheme, useMediaQuery } from "@material-ui/core";
import { includes, uniqBy } from "lodash";
import * as React from "react";
import { FETCH_USER_INFO } from "../../Fedx";
import { LocalCache } from "../../helpers/cache";
import { isArrayValid } from "../../helpers/utility";
import { useHubx } from "../../HubX";
import { BLOCK_FEATURE_ON_MOBILE_PERMISSIONS } from "../constants/blockedMobileFeatures";
import { SCACHE_USER } from "../constants/cacheKeys";
import EUser from "../contracts/EUser";
import {
  APP_PERMISSIONS,
  getPermissionFromEnum,
  PermissionsType,
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_APPROVE_CHARGE,
  PERMISSION_CONFIRM_CHARGE,
} from "../models/Permission";
import User from "../models/User";
import { get as lodashGet } from "lodash";

type useAuthType = {
  set: (token: string | null) => void;
  get: () => boolean;
  isSuperAdmin: boolean;
  hasPermission: (permissionType: PermissionsType) => boolean;
  hasAnyPermission: (permissionToCheck: PermissionsType[]) => boolean;
  mobileRestriction: (permissionToCheck: PermissionsType[]) => boolean;
};

const useAuth = (): useAuthType => {
  const cache = new LocalCache();
  const initialAuth = cache.get("bearer-token") ? true : false;
  const storedUser: EUser | null = cache.get(SCACHE_USER);
  const hub = useHubx();
  const theme = useTheme();
  const isMobileResolution = useMediaQuery(theme.breakpoints.down("xs"));

  React.useEffect(() => {
    const fetchUser = async () => {
      try {
        const UserFromAPI = await hub.request(FETCH_USER_INFO);
        cache.set(SCACHE_USER, UserFromAPI);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("useAuth → fetchUser -> error", error);
      }
    };

    if (!storedUser?.codigo) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storedUser]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setAuth] = React.useState(initialAuth);

  const set = (token: string | null) => {
    cache.set("bearer-token", token);
    setAuth(Boolean(token));
  };

  const get = () => {
    return cache.get("bearer-token") ? true : false;
  };

  const isSuperAdmin = Boolean(storedUser?.super_usuario);

  const getPermissions = React.useCallback(() => {
    if (isSuperAdmin) {
      // return APP_PERMISSIONS.map((x) => {
      //   return { type: x };
      // });

      return APP_PERMISSIONS;
    }

    // const permissions = storedUser?.installationGroup?.flatMap((group) => {
    //   return group?.permissionList ?? [];
    // });

    const permissions = [0];

    if (lodashGet(storedUser, "grupo.atualizacao_cadastral", false)) permissions.push(1);
    if (lodashGet(storedUser, "grupo.aprovacao_nivel1", false)) permissions.push(9);
    if (lodashGet(storedUser, "grupo.aprovacao_nivel2", false)) permissions.push(10);

    // return uniqBy(permissions, (x) => x?.type ?? "") ?? [];
    return permissions;
  }, [isSuperAdmin, storedUser]);

  //Avaliar se o cara tem a permissao
  const hasPermission = (permissionType: PermissionsType) => {
    if (permissionType === 0 || isSuperAdmin) {
      return get();
    }

    if (permissionType === PERMISSION_ACCESS_ADMIN)
      return lodashGet(storedUser, "grupo.atualizacao_cadastral", false);

    if (permissionType === PERMISSION_APPROVE_CHARGE)
      return lodashGet(storedUser, "grupo.aprovacao_nivel1", false);

    if (permissionType === PERMISSION_CONFIRM_CHARGE)
      return lodashGet(storedUser, "grupo.aprovacao_nivel2", false);
    return false;
  };

  const hasAnyPermission = (permissionToCheck: PermissionsType[]) => {
    const permissions = getPermissions();
    // const permissionsTypes = permissions?.map((x) => x.type);

    return permissionToCheck.some((permission) => permissions?.includes(permission));
  };

  const mobileRestriction = (permissionToCheck: PermissionsType[]) => {
    if (!isMobileResolution) {
      return false;
    }

    return permissionToCheck.every((permission) =>
      BLOCK_FEATURE_ON_MOBILE_PERMISSIONS.includes(permission)
    );
  };

  return { get, set, isSuperAdmin, hasPermission, hasAnyPermission, mobileRestriction };
};

export default useAuth;
